import Banner from 'shared-assets/components/Banner';

angular
  .module('app.shared-components.banner', [
    'react'
  ])
  .directive('banner', banner);

banner.$inject = ['reactDirective'];

function banner(reactDirective) {
  const bindings = {
    includeIcon: '=',
    type: '=',
    message: '=',
    truncateMessage: '=',
    style: '='
  };
  return reactDirective(Banner, bindings, props=>{return props;});
}